import type React from "react"
import { NavLink } from "react-router-dom"
import styled from "styled-components"
import { type ArbeidsarkIconKeys, type IconType, SVGIcon } from "../Icon"

interface WrapperProps {
  dropdownItem: boolean
  iconWidth: string
  iconLeft?: string
  iconTop?: string
}

const Wrapper = styled(NavLink)<WrapperProps>`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.primary10};
  user-select: none;
  svg {
    fill: ${(props) => props.theme.colors.primary10};
    ${(props) =>
      props.iconLeft ? `transform: translate(${props.iconLeft});` : ""}
    ${(props) =>
      props.iconTop ? `transform: translateY(${props.iconTop});` : ""}
  }

  gap: calc(12px + 16px - ${(props) => props.iconWidth});
  height: 47px;
  padding-left: 2.125rem;
  opacity: 0.6;

  ${(props) =>
    !props.dropdownItem &&
    `
      &:hover,
      &:focus {
        cursor: pointer;
        color: ${props.theme.colors.primary20};
        opacity: 1;
      }
      &.active {
        color: ${props.theme.colors.primary40};
        svg {
          fill: ${props.theme.colors.primary40};
        }
        opacity: 1;
        background: ${props.theme.colors.primary95};
      }
  `}

  ${(props) =>
    props.dropdownItem &&
    `
    color: ${props.theme.colors.gray60};
    svg {
      fill: ${props.theme.colors.gray60};
    }
    opacity: 1;

    &:hover, &:focus {
      color: ${props.theme.colors.gray40};
      svg {
        fill: ${props.theme.colors.gray40};
      }
      opacity: 1;
    }

    &.active {
      color: ${props.theme.colors.primary20};
      svg {
        fill: ${props.theme.colors.primary20};
      }
      opacity: 1;
    }


  `}
`

export interface SidebarNavItemProps {
  iconType?: IconType
  icon: ArbeidsarkIconKeys
  iconWidth?: string
  iconLeft?: string
  iconTop?: string
  to: string
  text: string
  dropdownItem?: boolean
  onClick?: () => void
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  iconType = "regular",
  icon,
  iconWidth = "16px",
  iconLeft,
  iconTop,
  to,
  text,
  dropdownItem = false,
  onClick,
}) => {
  return (
    <Wrapper
      to={to}
      onClick={onClick}
      dropdownItem={dropdownItem}
      iconLeft={iconLeft}
      iconTop={iconTop}
      iconWidth={iconWidth}
    >
      <SVGIcon icon={icon} type={iconType} width={iconWidth} />
      <div>{text}</div>
    </Wrapper>
  )
}
